var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("router-link", {
    attrs: { to: { name: "journey-overview" } },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var href = ref.href
          return [
            _c(
              "a",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { href: href }
              },
              [
                _c("i", { staticClass: "fas fa-route" }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.resource("JourneyBuilder_To_Overview_Button_Text")
                    ) +
                    "\n    "
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }